import { useState } from 'react';
import { Zap, Bell, Plus } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Alert } from '@/components/ui/Alert';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';
import { Tabs } from '@/components/ui/Tabs';
import { ModuleTogglePanel } from '@/components/dashboard/ModuleTogglePanel';

export function AutomationPage() {
  const [tab, setTab] = useState('autoresponder');

  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <h1 className="text-h1 text-text-primary mb-1">Automation</h1>
        <p className="text-small text-text-secondary">AutoResponder triggers and personal reminders.</p>
      </div>

      <ModuleTogglePanel
        module="reminders"
        title="Reminders"
        masterLabel="Enable /remindme in this server"
        permissionNote="Manage Server permission required. This is the server-wide feature switch — individual reminders are personal, not server configuration (see the tab below)."
      />

      <Alert
        tone="info"
        title="AutoResponder and personal reminders aren't connected yet"
        description="AutoResponder's config-only write path needs no manage_roles/message-send permission, so it's a comparatively low-risk feature to connect next (docs/WEB_API_REQUIREMENTS.md Feature 15). Personal reminders are per-user data, not server configuration, and were out of scope for this pass."
      />

      <Tabs
        tabs={[
          { id: 'autoresponder', label: 'AutoResponder' },
          { id: 'reminders', label: 'My Reminders' },
        ]}
        active={tab}
        onChange={setTab}
      />

      {tab === 'autoresponder' ? (
        <Card>
          <CardHeader
            title="Triggers"
            action={<Button variant="primary" disabled><Plus size={16} aria-hidden="true" />New trigger</Button>}
          />
          <EmptyState
            icon={Zap}
            title="No autoresponders yet"
            description="Once connected, this replaces 21 chat subcommands with one visual builder for triggers, embeds, buttons, variants, conditions, and cooldowns."
          />
        </Card>
      ) : (
        <Card>
          <CardHeader
            title="My reminders"
            description="Personal, not server-scoped — reminders belong to your account."
            action={<Button variant="primary" disabled><Plus size={16} aria-hidden="true" />New reminder</Button>}
          />
          <EmptyState icon={Bell} title="No reminders yet" description="Sign in with Discord to create one." />
        </Card>
      )}
    </div>
  );
}
